<div class="user-menu" [class.user-menu--open]="isOpen">
  <a
    aria-hidden="true"
    class="user-menu__trigger"
    data-cy="user-menu-trigger"
    (click)="toggleMenu()"
  >
    <span class="user-menu__name">{{ user.getFirstName() }}</span>
    <i class="pi pi-angle-down"></i>
  </a>
  <div class="user-menu__dropdown">
    @for (link of userDropdownOptions; track link) {
      @if (link.visible) {
        <div>
          @if (link.routerLink) {
            <a
              class="user-menu__item"
              [routerLink]="link.routerLink"
              routerLinkActive="active"
            >
              <i class="{{ link.icon }}"></i>
              {{ link.label }}
            </a>
          }
          @if (link.url) {
            <a class="user-menu__item" href="{{ link.url }}">
              <i class="{{ link.icon }}"></i>
              {{ link.label }}
            </a>
          }
          @if (link.callback) {
            <a
              aria-hidden="true"
              class="user-menu__item"
              (click)="callMethod(link.callback)"
            >
              <i class="{{ link.icon }}"></i>
              {{ link.label }}
            </a>
          }
        </div>
      }
    }
  </div>
</div>
